import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoListsReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_lists" />
);

export default KlaviyoListsReport;
